<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title9"> </title-bar>
    <!-- <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px">
      <img
        src="../../../assets/img/bonus/bonus9.png"
        width="100%"
        style="border-radius: 12px"
      />
    </div> -->
    <!-- <div style="position: relative; margin: 10px 10px 0 10px">
      <img
        src="../../../assets/img/bonus/bonus9.png"
        width="100%"
        style="border-radius: 13px"
      />
      <div style="position: absolute; top: 20px; left: 20px">
        <p
          style="font-weight: 800; font-size: var(--vk-fs-15); margin-bottom: 10px"
          v-html="$lang.common_txt244"
        ></p>
        <p v-html="$lang.common_txt245"></p>
      </div>
    </div> -->
    <div class="content-c">
      <div v-if="readError" class="signin-read-error">
        {{ readError }}
      </div>
      <div class="content-c--c t-c">
        <div
          style="
            width: 32%;
            background: #22232e;
            border-radius: 12px;
            margin-bottom: 10px;
          "
          v-for="(item, index) in singData"
          :key="index"
        >
          <div
            class="content-c--b"
            :class="{
              'active-b': index + 1 === new Date().getDay()
            }"
          >
            <p style="font-size: var(--vk-fs-base)" class="font-color">
              {{ $lang.common_txt192 }} {{ index + 1 }}
            </p>
            <!-- <div style="margin-top: 76px" class="divider"></div> -->
            <p style="margin-top: 76px" class="info-color">
              {{ getCurrency }} {{ singSum }}
            </p>
          </div>
        </div>
        <van-button
          size="large"
          class="custom-button"
          :class="{ active: isClaimUiDisabled() }"
          :disabled="claiming || isClaimUiDisabled()"
          @click="getJl"
        >
          {{ claiming ? ($lang.common_loading || 'Loading...') : $lang.Recebido }}
        </van-button>
      </div>

      <div class="content-c4">
        <div class="content-c2--c2t">
          {{ $lang.bonus_txt41 }}
        </div>
      </div>
      <div class="content-c5">
        {{ $lang.bonus_txt42 }}
      </div>

      <div class="content-c4">
        <div class="content-c2--c2t">
          {{ $lang.bonus_txt43 }}
        </div>
      </div>
      <div class="content-c3">
        <div class="content-c3--t font-color">
          <p>{{ $lang.bonus_txt36 }}</p>
          <p>{{ $lang.bonus_txt37 }}</p>
        </div>
        <div
          class="content-c3--t2 f-w"
          v-for="(item, index) in InitDate"
          :key="index"
          :style="(index + 1) % 2 === 0 ? {} : { backgroundColor: '#454654' }"
        >
          <p>VIP{{ item.vipLevel }}</p>
          <p>{{ item.reward }}</p>
        </div>
      </div>
      <van-loading v-if="loading" color="#ff5a1f" vertical> </van-loading>
    </div>
  </div>
</template>
<script>
import { GetSignIn, SignIn } from '@/api/common'
import { failMessage as rewardFailMessage, hasRewardIssueProof, hasUnavailableMarker, isClaimSuccess as rewardClaimSuccess, isNeedLogin, isOkResponse, responseContent } from '../activity/rewardApi'
export default {
  name: 'cashBack',
  components: {},
  data() {
    return {
      singData: [0, 1, 2, 3, 4, 5, 6],
      InitDate: [],
      info: {},
      loading: false,
      singSum: 0,
      readError: '',
      claiming: false
    }
  },
  mounted() {
    if (this.token) {
      this.GetSignIn()
    }
  },
  methods: {
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isRewardNeedLogin(res) {
      if (isNeedLogin(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (body.need_login === true || body.needLogin === true || [body.status, body.state, body.code, body.errorCode, body.need_login, body.needLogin].some(value => String(value || '').trim().toLowerCase() === 'need_login')) return true
        ;['content', 'data', 'page', 'extra'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasRewardUnavailableMarker(res) {
      if (hasUnavailableMarker(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.readOnly,
          body.readOnlyMode,
          body.read_only_mode,
          body.readOnlyReward,
          body.read_only_reward,
          body.readOnlyAction,
          body.read_only_action,
          body.read_only,
          body.mock_fallback,
          body.not_implemented,
          body.not_supported,
          body.need_login,
          body.needLogin,
          body.notSupported,
          body.unsupported,
          body.technicalMarker,
          body.technical_marker,
          body.backendFailure,
          body.backend_failure,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.fallback,
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.writeBlocked,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.falseProof,
          body.false_proof,
          body.failClosed,
          body.fail_closed,
          body.unimplemented,
          body.failed,
          body.readonly,
          body.notImplemented,
          body.mock,
          body.mockMode,
          body.mock_mode,
          body.mockFallback,
          body.write_blocked,
          body.stub,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.readOnlyMessage,
          body.unavailableReason,
          body.status,
          body.state,
          body.result,
          body.code,
          body.errorCode,
          body.paymentStatusUnconfirmed,
          body.payment_status_unconfirmed,
          body.paymentStatus,
          body.payment_status,
          body.rewardStatus,
          body.reward_status
        ]
        const proofValues = [
          body.writeProof,
          body.write_proof,
          body.rewardProof,
          body.reward_proof,
          body.orderProof,
          body.order_proof,
          body.affectedProof,
          body.affected_proof,
          body.serverProof,
          body.server_proof
        ]
        if (proofValues.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return true
        const markers = ['未接入', 'mock', 'mockMode', 'mock_mode', 'fallback', 'dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'stub', '只读', 'readOnlyMode', 'read_only_mode', 'readOnlyReward', 'read_only_reward', 'readOnlyAction', 'read_only_action', '阻止假成功', 'writeBlocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'writeProof', 'write_proof', 'writeProof:false', 'write_proof:false', 'falseProof', 'false_proof', 'false proof', 'failClosed', 'fail_closed', 'fail closed', 'backendBlocked', 'rewardBackendBlocked', 'backend_blocked', 'reward_backend_blocked', 'technicalMarker', 'technical_marker', 'technical marker', 'backendFailure', 'backend_failure', 'backend failure', 'technicalException', 'technical_exception', 'technical exception', 'technicalError', 'technical_error', 'technical error', 'not_implemented', 'not_supported', 'not supported', 'need_login', 'need login', 'need-login', 'unsupported', 'unimplemented', 'failed']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
    },
    safeToast(message, icon = 'cross') {
      if (typeof this.$toast === 'function') {
        this.$toast({
          message,
          icon
        })
      }
    },
    showFailToast(res, fallback) {
      this.safeToast(this.failMessage(res, fallback), 'cross')
    },
    readFailureMessage(res, fallback) {
      return `${this.failMessage(res, fallback)}，已保留已加载数据。`
    },
    showReadError(res, fallback) {
      this.readError = this.readFailureMessage(res, fallback)
      this.safeToast(this.readError, 'cross')
    },
    isClaimUiDisabled() {
      return !!this.readError || Number(this.info && this.info.receiveStatus) !== 1
    },
    isReadUnavailable(res) {
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.backendFailure,
          body.backend_failure,
          body.technicalMarker,
          body.technical_marker,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.unavailableReason
        ]
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return ['true', '1', 'dataunavailable', 'data_unavailable', 'data unavailable', 'readunavailable', 'read_unavailable', 'read unavailable', 'readblocked', 'read_blocked', 'read blocked', 'backendblocked', 'backend_blocked', 'backend blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'reward backend blocked', 'backendfailure', 'backend_failure', 'backend failure', 'technicalmarker', 'technical_marker', 'technical marker', 'technicalerror', 'technical_error', 'technical error', 'technicalexception', 'technical_exception', 'technical exception'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    safeRuleList(value) {
      if (Array.isArray(value)) return value
      if (!value) return []
      if (typeof value === 'string') {
        try {
          return this.safeRuleList(JSON.parse(value))
        } catch (e) {
          return []
        }
      }
      if (typeof value !== 'object') return []
      return this.firstRuleList(value)
    },
    firstRuleList(source, depth = 0) {
      if (!source || typeof source !== 'object' || depth > 5) return []
      const listKeys = ['ruleList', 'rules', 'list', 'records', 'dataList', 'items']
      for (const key of listKeys) {
        const value = source[key]
        if (Array.isArray(value)) return value
        if (typeof value === 'string') {
          const parsed = this.safeRuleList(value)
          if (parsed.length) return parsed
        }
      }
      const envelopeKeys = ['content', 'data', 'payload', 'extra', 'page', 'body']
      for (const key of envelopeKeys) {
        const value = source[key]
        if (!value || (typeof value !== 'object' && typeof value !== 'string')) continue
        const list = typeof value === 'string'
          ? this.safeRuleList(value)
          : this.firstRuleList(value, depth + 1)
        if (list.length) return list
      }
      return []
    },
    normalizeRuleList(list) {
      return this.safeRuleList(list)
        .filter((item) => item && typeof item === 'object' && (
          Object.prototype.hasOwnProperty.call(item, 'vipLevel') ||
          Object.prototype.hasOwnProperty.call(item, 'reward')
        ))
        .map((item) => ({
          ...item,
          vipLevel: Number(item && item.vipLevel) || 0,
          reward: Number(item && item.reward) || 0
        }))
    },
    isRewardWriteDisabled(content, source) {
      const c = content || {}
      return this.hasRewardUnavailableMarker(source || c) ||
        this.hasRewardUnavailableMarker(c) ||
        c.rewardWritable === false ||
        String(c.rewardWritable).trim().toLowerCase() === 'false' ||
        c.writeEnabled === false ||
        String(c.writeEnabled).trim().toLowerCase() === 'false'
    },
    claimableReceiveStatus(content, source) {
      const status = Number(content && content.receiveStatus) || 0
      return status === 1 && this.isRewardWriteDisabled(content, source) ? 0 : status
    },
    hasRewardWriteProof(res) {
      if (this.hasRewardUnavailableMarker(res)) return false
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const proofs = [
          body.writeProof,
          body.write_proof,
          body.affectedProof,
          body.affected_proof,
          body.affectedRowsProof,
          body.affected_rows_proof,
          body.count,
          body.serverProof,
          body.server_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (proofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return false
        const positiveProofs = [
          body.rewardProof,
          body.reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (positiveProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const recordProofs = [
          body.recordNo,
          body.record_no,
          body.recordId,
          body.record_id,
          body.rewardRecordNo,
          body.reward_record_no,
          body.rewardRecordId,
          body.reward_record_id,
          body.receiveRecordNo,
          body.receive_record_no,
          body.receiveRecordId,
          body.receive_record_id,
          body.claimRecordNo,
          body.claim_record_no,
          body.claimRecordId,
          body.claim_record_id
        ]
        const hasRecordProof = recordProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })
        const aliasProofs = [
          body.serverRewardProof,
          body.server_reward_proof
        ]
        if (hasRecordProof && aliasProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const concreteProofs = [
          body.rewardProof,
          body.reward_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (concreteProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasExplicitRewardSuccess(res) {
      const c = responseContent(res)
      return [
        c.receiveSuccess,
        c.claimSuccess,
        c.signSuccess,
        c.paySuccess,
        c.success,
        c.received,
        c.claimed,
        c.signed
      ].some(value => value === true || value === 1 || ['1', 'true', 'success', 'ok'].includes(String(value == null ? '' : value).trim().toLowerCase()))
    },
    isReceiveSuccess(res) {
      return !this.hasRewardUnavailableMarker(res) && rewardClaimSuccess(res) && this.hasExplicitRewardSuccess(res) && (hasRewardIssueProof(res) || this.hasRewardWriteProof(res)) && this.hasRewardWriteProof(res)
    },
    async getJl() {
      if (this.claiming) return
      if (this.isClaimUiDisabled()) {
        this.showFailToast(null, this.readError || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
        return
      }
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.claiming = true
      try {
        const data = await SignIn()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isReceiveSuccess(data)) {
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
          this.GetSignIn()
        } else {
          this.showFailToast(data)
        }
      } catch (e) {
        this.showFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      } finally {
        this.claiming = false
      }
    },
    async GetSignIn() {
      this.loading = true
      try {
        const data = await GetSignIn()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (isOkResponse(data) && !this.isReadUnavailable(data)) {
          const content = responseContent(data)
          const vipLevel = Number(content.vipLevel) || 0
          this.InitDate = this.normalizeRuleList(content)
          this.info = {
            ...content,
            vipLevel,
            awardAmount: Number(content.awardAmount) || 0,
            receiveStatus: this.claimableReceiveStatus(content, data)
          }
          const currentRule = this.InitDate.find(
            (i) => i.vipLevel === vipLevel
          )
          this.singSum = currentRule ? currentRule.reward : 0
          this.readError = ''
        } else {
          this.showReadError(data)
        }
      } catch (e) {
        this.showReadError(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding: 0% 3% 10% 3%;
  // position: absolute;
}
.signin-read-error {
  margin: 10px 0;
  padding: 10px 12px;
  border: 1px solid rgba(255, 187, 0, 0.45);
  border-radius: 8px;
  background: rgba(255, 187, 0, 0.08);
  color: #ffcf66;
  line-height: 18px;
}
.content-c--c {
  padding: 10px 0px;
  border-radius: 15px;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.content-c--b {
  padding-top: 5px;
  background: url('../../../assets/img/sign_in/sign_in_item_bg.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  // width: 110px;
  height: 120px;
  padding-bottom: 2px;
  position: relative; /* 设置为相对定位，以便添加伪元素 */
  border-radius: 15px;
}
.content-c--b3 {
  width: 100% !important;
}
.content-c--b2 {
  padding-top: 3px;
  background-image: url('../../../assets/img/sign_in/sign_in_item_bg1.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  // width: 346px;
  height: 120px;
  position: relative; /* 设置为相对定位，以便添加伪元素 */
  border-radius: 15px;
  border: 2px solid #076237; /* 边框 */
}
.active-b {
  /* 金色阴影效果 */
  // box-shadow: 0 1px 11px rgba(255, 215, 0, 0.8); /* 金色阴影 */
  border: 2px solid @info-color; /* 白色边框 */
  background-image: url('../../../assets/img/sign_in/sign_in_item_bg1.png'); /* 指定背景图片的路径 */
}

.active {
  // box-shadow: 0 4px 1px #4a4a4a !important; /* 阴影效果 */
  background: #9b9b9b !important;
  border-bottom: 0px solid #494949 !important;
}
.custom-button {
  opacity: 1;
  border-radius: 13px;
}

.content-c2 {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 18px;
  background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 320px; /* 或者指定具体的宽度 */
  padding: 2px 10px;
}
.content-c3--t {
  margin-top: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
  padding: 3.2% 77px 3.2% 67px;
  background: @cont-bg;
}
.content-c3--t2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 11% 12px 6%;
  background: @cont-bg;
  border-radius: 4px 4px 4px 4px;
}
.content-c3--t2 p {
  width: 40%;
  text-align: center;
}
.content-c3--t3 {
  // border-radius: 0 0 15px 15px;
  height: 0px;
  // background: @cont-bg;
}
.content-c3 :last-child {
  border-radius: 0 0 12px 12px !important;
}
.content-c4 {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 18px;
  // background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 360px; /* 或者指定具体的宽度 */
  padding: 3px 0px;
}
.content-c5 {
  // padding: 0 10px;
  // font-size: var(--vk-fs-15);
  margin-top: 15px;
  line-height: 20px;
  color: @font-color;
}
.divider {
  width: 60%;
  height: 2px;
  background-color: #ccc; // 你可以根据整体风格改颜色
  margin: 10px auto 0 auto;
}
/* PC 端样式 */
@media (min-width: 769px) {
  .content-c {
    width: var(--vk-pc-col);
    padding: 3% 1% 10% 1% !important;
  }
  .content-c3--t {
    padding: 3.2% 98px 3.2% 85px;
  }
}
</style>
